<section class="static-page">
  <header class="static-header">
    <span class="static-icon" aria-hidden="true"><i class="fa-solid fa-shield-halved"></i></span>
    <h1>Security</h1>
    <p class="static-subtitle">How we protect your business data on orderYaa ERP.</p>
  </header>

  <div class="container">
    <div class="static-content">
      <p>
        Your sales, inventory, and financial data are core to your business — we treat protecting
        them as a core part of the product, not an afterthought.
      </p>

      <h2>Data in transit</h2>
      <p>
        All traffic between the app, our APIs, and our servers is encrypted using HTTPS/TLS.
        Nothing is sent to our backend over an unencrypted connection.
      </p>

      <h2>Account access</h2>
      <ul>
        <li>Every user signs in with their own login — no shared admin passwords</li>
        <li>Role-based permissions control what each user can see and do</li>
        <li>Cashier PINs and session controls protect POS terminals in-store</li>
      </ul>

      <h2>Data separation</h2>
      <p>
        Each business's data — companies, branches, and business units — is logically separated
        so one customer's data is never visible to another.
      </p>

      <h2>Infrastructure</h2>
      <p>
        Our backend runs on managed cloud infrastructure with regular backups, so your sales and
        accounting records are recoverable in the event of a failure.
      </p>

      <h2>Reporting a security issue</h2>
      <p>
        If you believe you've found a security vulnerability in orderYaa, please report it to us
        directly rather than disclosing it publicly, so we can investigate and fix it before it
        affects customers.
      </p>
      <p>When you report an issue, please include:</p>
      <ul>
        <li>Steps to reproduce the issue</li>
        <li>The affected module or endpoint</li>
        <li>What you were able to access or do that you shouldn't have been able to</li>
      </ul>
      <p>
        We acknowledge every report within 2 business days and will follow up with you directly
        as we investigate.
      </p>

      <div class="static-cta">
        <a
          class="btn btn-security"
          href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=hr@techcolleagues.com&amp;su=Security%20Vulnerability%20Report&amp;body=Affected%20module%2Fendpoint%3A%0ASteps%20to%20reproduce%3A%0AImpact%3A%0A"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
          Report a security issue
        </a>
      </div>
    </div>
  </div>
</section>
